import React from 'react'

type TrustedSvgProps = {
  svgString: string
  width?: number | string
  height?: number | string
}

export const TrustedSvg: React.FC<TrustedSvgProps> = ({ svgString, width, height }) => (
  <div
    style={{
      width: width ? width : undefined,
      height: height ? height : undefined,
      display: 'inline-block',
    }}
    dangerouslySetInnerHTML={{
      __html:
        svgString?.replace('<svg', `<svg width="${width || 32}" height="${height || 32}"`) ?? '',
    }}
  />
)
